export default "__VITE_ASSET__DdSsXDoh__"